import React, { Component } from 'react'
import { Dialog, Tag } from "@blueprintjs/core";
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
    withRouter
} from 'react-router-dom'

import './KeysDevice.css'

import { setPropDataObject, salvar, close } from '../../actions/acesso/CadAcesso'

class KeysDevice extends Component {
    constructor(props) {
        super(props)
    }

    close() {
        this.props.onClose()
    }

    render() {
        let { isOpen, keys } = this.props
        if (keys)
            return (
                <Dialog isOpen={isOpen} onClose={() => { this.close() }} title="Chaves do dispositivo" canEscapeKeyClose={false} canOutsideClickClose={false}>
                    <div className="pt-dialog-body">
                        <div className="pt-card .modifier">
                            {keys.keys.map(key => {
                                return <Tag className=" bp3-round bp3-large space" key={key.value} >{ key.value } </Tag>
                            })}
                        </div>
                    </div>
                </Dialog>
            )
    }
}

function mapStateToProps(state) {
    let { keys } = state.coDispositivo
    return {
        keys
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ close }, dispatch)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(KeysDevice))


// WEBPACK FOOTER //
// ./src/scenes/dispositivo/KeysDevice.js